<template>
  <div style="padding-top: env(safe-area-inset-top);">
    <van-nav-bar title="" left-text="back" left-arrow @click-left="onClickLeft" />
    <div id="app">
      <div class="list-box">
        <div class="title">BANK INFO</div>
        <div>
          <div class="font-16 left-text">ACCOUNT NUMBER</div>
          <van-cell-group> <van-field v-model="form.accountNumber" :border="true" /></van-cell-group>
        </div>

        <div>
          <div class="font-16 left-text">BANK NAME</div>
          <van-cell-group> <van-field v-model="form.bankName" :border="true" /></van-cell-group>
        </div>
        <div>
          <div class="font-16 left-text">IFSC</div>
          <van-cell-group> <van-field :border="true" v-model="form.ifsc" /></van-cell-group>
        </div>
        <div>
          <div class="font-16 left-text">NODIA BRANCH</div>
          <van-cell-group> <van-field :border="true" v-model="form.branchBank" /></van-cell-group>
        </div>
      </div>
      <div class="fixed repay-box margin-top-30 ">
        <div class="theme-back repay" @click="editBankInfo">
          NEXT
        </div>
      </div>

      <van-popup v-model="show" position="bottom" round :style="{ height: '30%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="select" :min-date="minDate" :max-date="maxDate"
        confirm-button-text="confirm" cancel-button-text="cancel"
          @cancel="show = false" @confirm="confirm" />
      </van-popup>

      <van-overlay :show="showOverlay">
        <div class="wrapper">
          <van-loading />
        </div>
      </van-overlay>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        accountNumber: '',
        bankName: '',
        ifsc: '',
        branchBank: '',
      },
      userToken: "",
      show: false,
      showOverlay: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
    }
  },
  created() {
    this.userToken = window.localStorage.getItem('token')
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    confirm(value) {
      this.form.birthday = value.getFullYear() + "-" + (value.getMonth() + 1) + "-" + value.getDate()
      this.show = false
    },
    async editBankInfo() {
      const { data: result } = await this.$http.post('/api/user/info')
      if (result.data.is_operator) {
        const { data: res } = await this.$http.post('/api/user/editBankInfo', this.form)
        if (res.code === 0) {
          this.$router.push({
            name: 'photoproofs'
          })
        } else {
          this.$toast(res.msg)
        }
      } else {
        this.showOverlay = true
        // const u = navigator.userAgent;
        // //android终端
        // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        // // IOS终端
        // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // if (isiOS) {
        //   window.webkit.messageHandlers.getContactList.postMessage(this.userToken);
        //   //你的逻辑代码
        // } else if (isAndroid) {
        //   window.Android.getContactList(this.userToken)
        //   // 你的逻辑代码
        // }

        // for (let i = 0; i < 30; i++) { // 例如，循环10次
        //   const { data: result } = await this.$http.post('/api/user/info')
        //   if (result.data.is_operator) {
            this.showOverlay = false
            const { data: res } = await this.$http.post('/api/user/editBankInfo', this.form)
            if (res.code === 0) {
              this.$router.push({
                name: 'photoproofs'
              })
              // break;
            } else {
              this.$toast(res.msg)
            }
        //   }
        //   setTimeout(function () {
        //     console.log(i);
        //   }, 1000);
        // }
        // this.showOverlay = false
        // this.$toast("getContactList fail")
      }


    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}


.van-cell {
  padding: 14px 0px;
}

#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 30px 12px;
  box-sizing: border-box;


  .list-box {
    margin-bottom: 67px;
    background: #FFFFFF;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    padding: 13px 14px;
  }


  .title {
    font-size: 15px;
    color: #FFA06A;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .left-text {
    color: #101010;
  }

  .repay-box {
    bottom: 10px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 299px;

    .repay {
      padding: 12px 128px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
      border-radius: 24px;
    }
  }

}
</style>
